<template>
  <div class="pos-abs-fixed">
    <v-toolbar
      dense 
      flat
      tabs
      color="grey lighten-2"
      class="border-bottom"
    >
      <v-toolbar-title class="title">{{ formTitle }}</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <Menu 
        :items="menuItems"
        @voltaStatus="voltaStatusItem"
        itemAction="action"
      />
      <v-tooltip bottom>
        <v-btn fab small icon @click="close" slot="activator">
          <v-icon dark>close</v-icon>
        </v-btn>
        <span>Cancelar</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn fab dark small color="primary" icon @click="save" slot="activator" :loading="loadingAtividade">
          <v-icon>done</v-icon>
        </v-btn>
        <span>Salvar</span>
      </v-tooltip>

      <template v-slot:extension>
        <Tabs
          :currentTab="tab"
          :tabsHeader="tabsHeader"
          @tabChanged="tabChanged"
        />

        <v-spacer></v-spacer>

        <template v-if="tab == 2">
          <v-text-field 
            class="pt-0"
            v-show="showSearch"
            @input="search"
            @keyup.esc="showSearch = false"
            prepend-inner-icon="search"
            clearable
            hide-details
            autofocus
          ></v-text-field>

          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="showSearch = !showSearch">
              <v-icon>{{ iconSearch }}</v-icon>
            </v-btn>
            <span>Pesquisar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <v-btn
              icon
              slot="activator"
              @click="getAtividadeAtividades"
              :loading="loading"
            ><v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>

          <v-tooltip bottom v-if="permiteAlterar">
            <span>Opções</span>
            <v-menu bottom left slot="activator">
              <v-btn flat icon small slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="abreModalAtividadesVincular">
                  <v-list-tile-title>
                    <v-icon small left>add_circle</v-icon>Vincular Atividades
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="removerVinculoAtividade">
                  <v-list-tile-title>
                    <v-icon small left>remove_circle</v-icon>Remover Vínculo
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="editItemSelected">
                  <v-list-tile-title>
                    <v-icon small left>edit</v-icon>Alterar
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="deleteItemSelected">
                  <v-list-tile-title>
                    <v-icon small left>delete</v-icon>Excluir
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="finalizaItemSelected">
                  <v-list-tile-title>
                    <v-icon small left>check</v-icon>Finalizar
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="voltaStatusItemSelected">
                  <v-list-tile-title>
                    <v-icon small left>undo</v-icon>Voltar Status
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditPrevisao">
                  <v-list-tile-title>
                    <v-icon small left>event</v-icon>Setar Previsão
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditSituacao">
                  <v-list-tile-title>
                    <v-icon small left>description</v-icon>Setar Situação
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditResponsavel">
                  <v-list-tile-title>
                    <v-icon small left>person</v-icon>Setar Responsável
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditTipoAtividade">
                  <v-list-tile-title>
                    <v-icon small left>label_important</v-icon>Setar Tipo Atividade
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditColaborador">
                  <v-list-tile-title>
                    <v-icon small left>group_add</v-icon>Setar Colaborador
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditCliente">
                  <v-list-tile-title>
                    <v-icon small left>group_add</v-icon>Setar Cliente
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalSetaOcorrencia">
                  <v-list-tile-title>
                    <v-icon small left>comment</v-icon>Setar Ocorrência
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="abreModalEditTag">
                  <v-list-tile-title>
                    <v-icon small left>label</v-icon>Setar Tag
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-tooltip>
        </template>
      </template>
    </v-toolbar>
    <v-tabs-items
      v-if="!loadingPage"
      :value="tab" style="padding-top: 85px;"
    >
      <!-- Dados -->
      <v-tab-item>
        <v-container fluid px-3>
          <v-layout wrap>
            <v-flex xs12 md9>
              <v-card>
                <v-card-text class="atividade-detalhes">
                  <div v-if="atividade.DataEmissao" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Emissão</h6>
                    <v-chip color="default">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(atividade.DataEmissao).format('DD [de] MMM [de] YYYY [às] HH:mm') }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.DataPrevisao" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Previsão</h6>
                    <v-chip color="warning" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(atividade.DataPrevisao).format('DD [de] MMM [de] YYYY') }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.DataFinalizacao" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Finalização</h6>
                    <v-chip color="success" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>event</v-icon>
                      </v-avatar>
                      {{ moment(atividade.DataFinalizacao).format('DD [de] MMM [de] YYYY [às] HH:mm') }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.Situacao" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Situação</h6>
                    <v-chip :color="atividade.Cor" text-color="white">
                      <v-avatar class="mr-0">
                        <v-icon small>description</v-icon>
                      </v-avatar>
                      {{ atividade.Situacao }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.Duracao" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Duração</h6>
                    <v-chip>
                      <v-avatar class="mr-0">
                        <v-icon small>access_time</v-icon>
                      </v-avatar>
                      {{ duracaoItem(atividade.Duracao) }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.Status" class="atividade-detalhes-item mr-2 mb-1">
                    <h6 class="atividade-detalhes-item-header subheading">Status</h6>
                    <v-avatar class="mt-1" size="32" :color="statusAtividade(atividade.Status)">
                      <span class="white--text">{{ atividade.Status[0] }}</span>
                    </v-avatar>
                  </div>
                  <div v-if="atividadeColaboradores.length" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">Colaboradores</h6>
                    <v-chip
                      :disabled="!permiteAlterar"
                      @input="excluiColaborador(colaborador)" 
                      close v-for="colaborador in atividadeColaboradores" :key="colaborador.IdColaborador">
                      <v-avatar class="primary white--text">{{ colaborador.Colaborador[0] }}</v-avatar>
                      {{ colaborador.Colaborador }}
                    </v-chip>
                  </div>
                  <div v-if="atividadeClientes.length" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">Clientes</h6>
                    <v-chip 
                      :disabled="!permiteAlterar"
                      @click.stop="infoClient(cliente)"
                      @input="excluiCliente(cliente)" 
                      close 
                      v-for="(cliente, index) in atividadeClientes" :key="index">
                      <v-avatar class="primary white--text">{{ cliente.Fantasia[0] }}</v-avatar>
                      {{ cliente.Fantasia }}
                    </v-chip>
                  </div>
                  <div v-if="atividadeTags.length" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">Tags</h6>
                    <v-chip 
                      :disabled="!permiteAlterar"
                      @input="excluiTag(tag)"
                      close v-for="tag in atividadeTags" :key="tag.IdTag">
                      {{ tag.Descricao }}
                    </v-chip>
                  </div>
                  <div v-if="atividadeProjetos.length" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">Projetos</h6>
                    <v-chip
                      v-for="projeto in atividadeProjetos"
                      :key="projeto.IdProjeto"
                      @click.stop="abreModalInfoProjeto(projeto)"
                      :color="corStatus(projeto.Status)"
                      dark
                    >
                      {{ projeto.Projeto }}
                    </v-chip>
                  </div>
                  <div v-if="atividade.ValorGut" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">GUT</h6>
                    <v-progress-circular
                      :size="36"
                      :value="atividade.ValorGut || 0"
                      :color="matrizGutColor(atividade.ValorGut || 0)"
                    >
                      <span class="font-weight-medium">{{ atividade.ValorGut || 0 }}</span>
                    </v-progress-circular>
                  </div>
                  <div v-if="atividade.ValorNps !== null && atividade.ValorNps !== undefined" class="atividade-detalhes-item interessados mr-2">
                    <h6 class="atividade-detalhes-item-header subheading">NPS</h6>
                    <v-progress-circular
                      :size="36"
                      :value="npsValue(atividade.ValorNps)"
                      :color="npsColor(atividade.ValorNps)"
                    >
                      <span class="font-weight-medium">{{ atividade.ValorNps }}</span>
                    </v-progress-circular>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="my-3">
                <v-card-text class="pb-0">
                  <v-form
                    v-model="valid"
                    ref="formAtividade"
                    @submit.prevent="save"
                  >
                    <v-text-field
                      :disabled="!permiteAlterar"
                      :value="atividade.Descricao"
                      @change="v => atividade.Descricao = v"
                      label="Descrição"
                      :rules="[rules.required]"
                      required
                      outline
                    ></v-text-field>
                  </v-form>
                </v-card-text>
              </v-card>
              <!-- <v-card>
                <v-card-title class="py-0">
                  <span class="subheading font-weight-medium">Observações</span>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      slot="activator"
                      @click="mostraInputObservacoes = !mostraInputObservacoes"
                    ><v-icon>{{ iconInputObservacoes }}</v-icon>
                    </v-btn>
                    <span>Editar</span>
                  </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="!mostraInputObservacoes">
                  <div class="markdown-container prewrap" v-html="compileMarkdown(atividade.Observacoes)"></div>
                </v-card-text>
                <v-card-text v-else>
                  <SharedTextarea
                    :disabled="!permiteAlterar"
                    :value="atividade.Observacoes"
                    @change="v => atividade.Observacoes = v"
                    label="Observações"
                    hide-details
                    outline
                  />
                </v-card-text>
              </v-card> -->
              <!-- Checklists -->
              <v-card class="mt-3">
                <v-card-title class="py-0">
                  <span class="subheading font-weight-medium">Checklist</span>
                  <v-spacer></v-spacer>
                  <v-flex xs3>
                    <v-progress-linear 
                      :color="progressColor(atividadeProgresso)"
                      height="20" 
                      :value="atividadeProgresso"
                      class="text-xs-center z-index-1"
                      >
                      {{ atividadeProgresso }}%
                    </v-progress-linear>
                  </v-flex>
                  <v-tooltip bottom v-if="!inputChecklist && !editandoChecklist && permiteAlterar">
                    <v-btn
                      fab dark small color="primary" 
                      @click="mostraInputChecklist" slot="activator">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>Adicionar</span>
                  </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="checklists">
                  <div class="checklist">
                    <div class="checklist-body">
                      <v-layout row wrap>
                        <v-flex xs12 v-for="checklist in checklistsOrdenados" :key="checklist.IdChecklist">
                          <v-layout row wrap v-if="editandoChecklist !== checklist.IdChecklist">
                            <v-checkbox
                              :disabled="!permiteAlterar"
                              v-model="checklist.Concluido"
                              color="primary"
                              :label="checklist.Descricao"
                              hide-details
                              height="0"
                              @change="concluiChecklist(checklist)"
                            ></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-tooltip bottom v-if="permiteAlterar">
                              <v-btn icon flat small class="mx-0" slot="activator" @click="editaChecklist(checklist)">
                                <v-icon small>edit</v-icon>
                              </v-btn>
                              <span>Editar</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="permiteAlterar">
                              <v-btn icon flat small class="mx-0" slot="activator" @click="excluiChecklist(checklist)">
                                <v-icon small>delete</v-icon>
                              </v-btn>
                              <span>Excluir</span>
                            </v-tooltip>
                          </v-layout>
                          <!-- Input Edita Checklist -->
                          <v-layout row wrap v-if="editandoChecklist == checklist.IdChecklist">
                            <v-flex xs12>
                              <v-layout row align-center>
                                <v-text-field 
                                  :value="editAtividadeChecklist.Descricao"
                                  @change="v => editAtividadeChecklist.Descricao = v"
                                  label="Edita Checklist" 
                                  prepend-icon="folder" 
                                  id="checklist-edit-item" 
                                  @keyup.enter="adicionaChecklist"
                                  @keyup.esc="cancelaEditaChecklist(checklist)" 
                                ></v-text-field>
                                <v-tooltip bottom>
                                  <v-btn fab flat small @click="cancelaEditaChecklist(checklist)" slot="activator">
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                  <span>Cancelar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <v-btn fab dark small color="primary" icon @click="adicionaChecklist" slot="activator">
                                    <v-icon>done</v-icon>
                                  </v-btn>
                                  <span>Salvar</span>
                                </v-tooltip>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                  <!-- Input Checklist -->
                  <v-layout row align-center v-if="inputChecklist && !editandoChecklist">
                    <v-text-field 
                      :value="atividadeChecklist.Descricao"
                      @change="v => atividadeChecklist.Descricao = v"
                      label="Adicionar Checklist" 
                      prepend-icon="folder" 
                      id="checklist-add-item" 
                      @keyup.enter="adicionaChecklist" 
                      @keyup.esc="inputChecklist = false"
                    ></v-text-field>
                    <v-tooltip bottom>
                      <v-btn fab flat small @click="inputChecklist = false" slot="activator">
                        <v-icon>close</v-icon>
                      </v-btn>
                      <span>Cancelar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn fab dark small color="primary" icon @click="adicionaChecklist" slot="activator" :loading="loadingChecklist">
                        <v-icon>done</v-icon>
                      </v-btn>
                      <span>Salvar</span>
                    </v-tooltip>
                  </v-layout>
                </v-card-text>
              </v-card>
              <!-- Ocorrências -->
              <v-card class="my-3">
                <v-card-title class="py-0">
                  <span class="subheading font-weight-medium">Ocorrências</span>
                  <v-spacer></v-spacer>
                  <v-btn 
                    small
                    color="grey lighten-2"
                    @click="hideLogOcorrencias = !hideLogOcorrencias"
                  >{{ hideLogOcorrenciasText }}</v-btn>
                  <v-tooltip bottom v-if="!inputOcorrencia">
                    <v-btn
                      icon
                      :loading="loadingOcorrencia"
                      @click="getAtividadeOcorrencias"
                      slot="activator">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                    <span>Atualizar</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!inputOcorrencia">
                    <v-btn fab dark small color="primary" @click="mostraInputOcorrencia" slot="activator">
                      <v-icon dark>add</v-icon>
                    </v-btn>
                    <span>Adicionar</span>
                  </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="inputOcorrencia" class="pt-0">
                  <v-form
                    v-model="validOcorrencia"
                    ref="formOcorrencia"
                    @submit.prevent="adicionaOcorrencia"
                  >
                    <v-layout row wrap>
                      <v-flex xs12 class="pa-0">
                        <v-autocomplete
                          v-model="modeloOcorrencia"
                          :items="modelosOcorrenciaAtivo"
                          item-text="Descricao"
                          return-object
                          menu-props="auto"
                          label="Modelo Ocorrencia"
                          hide-details
                          prepend-icon="label_important"
                          class="mb-3"
                          auto-select-first
                          no-data-text="Registro não encontrado"
                          @change="changeModeloOcorrencia"
                        ></v-autocomplete>
                        <SharedTextarea
                          :value="atividadeOcorrencia.Descricao"
                          @change="v => atividadeOcorrencia.Descricao = v"
                          textareaId="ocorrencia-add" 
                          label="Adicionar Ocorrência" 
                          required
                          outline
                          :rules="[rules.required]"
                          @esc="inputOcorrencia = false"
                        >
                          <v-flex xs12 md4 :pr-3="$vuetify.breakpoint.smAndUp">
                            <v-autocomplete 
                              v-model="atividadeOcorrencia.TipoOcorrencia"
                              :items="tiposOcorrenciaFiltro"
                              item-text="Descricao"
                              return-object
                              menu-props="auto"
                              label="Tipo Ocorrência"
                              :hide-details="$vuetify.breakpoint.mdAndUp"
                              prepend-icon="label"
                              @change="changeTipoOcorrencia"
                              auto-select-first
                              no-data-text="Registro não encontrado."
                              class="mt-0"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs12 md2>
                            <v-text-field 
                              v-model="duracao"
                              mask="time" 
                              return-masked-value 
                              prepend-icon="access_time"
                              @click:prepend="calculaDuracaoOcorrencia(atividadeOcorrencia.DataOcorrencia)"
                              label="Duração" 
                              :hide-details="$vuetify.breakpoint.mdAndUp"
                              placeholder="00:00"
                              @keyup.enter="adicionaOcorrencia"
                              @keyup.esc="inputOcorrencia = false"
                              class="mt-0"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md5>
                            <v-tooltip bottom>
                              <v-btn flat fab small icon @click="inputOcorrencia = false" slot="activator">
                                <v-icon>close</v-icon>
                              </v-btn>
                              <span>Cancelar</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                              <v-btn fab dark small color="primary" @click="adicionaOcorrencia" slot="activator" :loading="loadingOcorrencia">
                                <v-icon>done</v-icon>
                              </v-btn>
                              <span>Salvar</span>
                            </v-tooltip>
                          </v-flex>
                        </SharedTextarea>
                        <!-- <v-textarea 
                          :value="atividadeOcorrencia.Descricao"
                          @change="v => atividadeOcorrencia.Descricao = v"
                          id="ocorrencia-add" 
                          label="Adicionar Ocorrência" 
                          required
                          :rules="[rules.required]"
                          @keyup.esc="inputOcorrencia = false"
                        ></v-textarea> -->
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
              </v-card>
              <!-- Historico de Ocorrências -->
              <v-flex xs12 class="ocorrencias-container">
                <div 
                  v-for="(ocorrencia, index) in filteredOcorrencias" 
                  :key="index" 
                  :class="ordemOcorrencia(ocorrencia.IdTipoOcorrencia)"
                >
                  <v-card 
                    v-if="ocorrencia.IdTipoOcorrencia !== 2" 
                    class="mb-3" 
                    :color="ocorrenciaFinal(ocorrencia.IdTipoOcorrencia)"
                  >
                    <v-card-title primary-title class="pt-2">
                      <v-flex xs12 v-if="editandoOcorrencia !== ocorrencia.IdOcorrencia">
                        <v-layout row align-center>
                          <v-flex xs12 md8>
                            <p class="font-weight-bold ma-0">
                              {{ ocorrencia.Colaborador }}
                              <span class="caption grey--text text--darken-4">
                                {{ moment(ocorrencia.DataOcorrencia).format('lll') }} 
                                (Duração: {{ duracaoItem(ocorrencia.Duracao) }})
                              </span>
                            </p>
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-chip 
                            v-if="ocorrencia.IdTipoOcorrencia === 3"
                            color="success lighten-4"
                          >
                            <v-avatar class="white">
                              <v-icon>check</v-icon>
                            </v-avatar>
                            <span>Finalização</span>
                          </v-chip>
                          <v-card-actions v-if="permiteAlterarExcluir(ocorrencia)">
                            <v-btn icon flat small @click="editaOcorrencia(ocorrencia)">
                              <v-icon small>edit</v-icon>
                            </v-btn>
                            <v-btn icon flat small @click="excluiOcorrencia(ocorrencia)">
                              <v-icon small>delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-layout>
                        <v-divider></v-divider>
                        <div class="markdown-container mt-2">
                          <div class="prewrap" v-html="compileMarkdown(ocorrencia.Descricao)"></div>
                          <!-- <p class="prewrap mb-0">{{ ocorrencia.Descricao }}</p> -->
                        </div>
                      </v-flex>
                      <!-- Edita Ocorrência -->
                      <v-layout v-if="editandoOcorrencia == ocorrencia.IdOcorrencia" row wrap>
                        <v-flex xs12>
                          <v-autocomplete
                            v-model="modeloOcorrencia"
                            :items="modelosOcorrenciaAtivo"
                            item-text="Descricao"
                            return-object
                            menu-props="auto"
                            label="Modelo Ocorrencia"
                            hide-details
                            prepend-icon="label_important"
                            class="mb-3"
                            auto-select-first
                            no-data-text="Registro não encontrado"
                            @change="changeModeloOcorrencia"
                          ></v-autocomplete>
                            <SharedTextarea
                              :value="editAtividadeOcorrencia.Descricao"
                              @change="v => editAtividadeOcorrencia.Descricao = v"
                              textareaId="ocorrencia-edit-item" 
                              label="Edita Ocorrência" 
                              required
                              outline
                              :rules="[rules.required]"
                              @esc="cancelaEditaOcorrencia(ocorrencia)" 
                            >
                              <v-flex xs12 md4 :pr-3="$vuetify.breakpoint.smAndUp">
                                <v-autocomplete 
                                  v-model="editAtividadeOcorrencia.TipoOcorrencia"
                                  :items="tiposOcorrenciaFiltro"
                                  item-text="Descricao"
                                  return-object
                                  menu-props="auto"
                                  label="Tipo Ocorrência"
                                  :hide-details="$vuetify.breakpoint.mdAndUp"
                                  prepend-icon="label"
                                  no-data-text="Registro não encontrado."
                                  auto-select-first
                                  @change="changeTipoOcorrencia"
                                  class="mt-0"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-text-field 
                                  v-model="duracao"
                                  mask="time" 
                                  return-masked-value 
                                  label="Duração" 
                                  prepend-icon="access_time" 
                                  @click:prepend="calculaDuracaoOcorrencia(editAtividadeOcorrencia.DataOcorrencia)"
                                  placeholder="00:00" 
                                  :hide-details="$vuetify.breakpoint.mdAndUp"
                                  @keyup.enter="adicionaOcorrencia"
                                  @keyup.esc="cancelaEditaOcorrencia(ocorrencia)"
                                  class="mt-0"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 md5>
                                <v-tooltip bottom>
                                  <v-btn fab flat small @click="cancelaEditaOcorrencia(ocorrencia)" slot="activator">
                                    <v-icon>close</v-icon>
                                  </v-btn>
                                  <span>Cancelar</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <v-btn fab dark small color="primary" @click="adicionaOcorrencia" slot="activator" :loading="loadingOcorrencia">
                                    <v-icon>done</v-icon>
                                  </v-btn>
                                  <span>Salvar</span>
                                </v-tooltip>
                              </v-flex>
                            </SharedTextarea>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                  </v-card>
                  <!-- Ocorrencia do tipo 2 (LOG) -->
                  <div v-if="ocorrencia.IdTipoOcorrencia === 2" class="pl-3 mb-3">
                    <p class="font-weight-bold mb-0">
                      {{ ocorrencia.Colaborador }}
                      <span class="prewrap mb-0 font-weight-regular">{{ ocorrencia.Descricao }}</span>
                    </p>
                    <span class="caption grey--text text--darken-3">
                      {{ moment(ocorrencia.DataOcorrencia).format('lll') }}
                    </span>
                  </div>
                </div>
              </v-flex>
            </v-flex>
            <!-- Coluna Detalhes Atividade -->
            <v-flex xs12 md3 :class="{ 'pl-4': $vuetify.breakpoint.mdAndUp }">
              <v-card>
                <v-card-text>
                  <div class="d-flex align-center">
                    <v-flex xs1 v-if="existeOcorrenciaExecucaoPendente() || atividade.Status.startsWith('P')">
                      <v-icon>settings</v-icon>
                    </v-flex>
                    <v-flex xs11>
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          v-if="!existeOcorrenciaExecucaoPendente() && atividade.Status.startsWith('P')"
                          small
                          color="primary"
                          @click="iniciaExecucaoAtividade"
                        ><v-icon>play_arrow</v-icon>
                        </v-btn>
                        <span>Iniciar Execução</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          v-if="existeOcorrenciaExecucaoPendente()"
                          small
                          color="error"
                          @click="paraExecucaoAtividade"
                        ><v-icon>pause</v-icon>
                        </v-btn>
                        <span>Parar Execução</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <v-btn
                          slot="activator"
                          v-if="existeOcorrenciaExecucaoPendente()"
                          small
                          color="success"
                          @click="finalizaExecucaoAtividade"
                        ><v-icon>done</v-icon>
                        </v-btn>
                        <span>Finalizar Execução</span>
                      </v-tooltip>
                    </v-flex>
                  </div>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.Responsavel"
                    :items="colaboradores"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Responsável"
                    hide-details
                    prepend-icon="person"
                    class="mb-3"
                    no-data-text="Registro não encontrado."
                    auto-select-first
                    @change="changeResponsavel"
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.TipoAtividade"
                    :items="tiposAtividadeAtivo"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Tipo Atividade"
                    hide-details
                    prepend-icon="label_important"
                    class="mb-3"
                    no-data-text="Registro não encontrado."
                    auto-select-first
                    @change="changeTipoAtividade"
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.Workflow"
                    :items="workflows"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Workflow"
                    hide-details
                    prepend-icon="timeline"
                    class="mb-3"
                    no-data-text="Registro não encontrado."
                    auto-select-first
                    clearable
                    @change="changeWorkflow"
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividadeTag.Descricao"
                    :items="tagsAtivo"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Tags"
                    hide-details
                    prepend-icon="label"
                    class="mb-3"
                    @change="changeTag"
                    auto-select-first
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividadeColaborador.Colaborador"
                    :items="colaboradores"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Colaboradores"
                    hide-details
                    prepend-icon="group_add"
                    class="mb-3"
                    @change="changeColaborador"
                    auto-select-first
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividadeCliente.Fantasia"
                    :items="clientesAtivo"
                    item-text="Fantasia"
                    return-object
                    menu-props="auto"
                    label="Clientes"
                    hide-details
                    prepend-icon="group_add"
                    class="mb-3"
                    @change="changeClientes"
                    auto-select-first
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-menu v-model="atividadeDatepicker" :close-on-content-click="false" full-width :disabled="!permiteAlterar">
                    <v-text-field slot="activator"
                      :value="moment(dataPrevisao).format('DD/MM/YYYY')" label="Previsão" prepend-icon="event" :disabled="!permiteAlterar">
                    </v-text-field>
                    <v-date-picker locale="pt" v-model="dataPrevisao" @change="changeAtividadeDatepicker"></v-date-picker>
                  </v-menu>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.Situacao"
                    :items="situacoesAtividade"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Situação"
                    hide-details
                    prepend-icon="description"
                    class="mb-3"
                    auto-select-first
                    no-data-text="Registro não encontrado."
                    @change="changeSituacao"
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.Prioridade"
                    :items="prioridadesAtivo"
                    item-text="Descricao"
                    return-object
                    menu-props="auto"
                    label="Prioridade"
                    hide-details
                    prepend-icon="flag"
                    class="mb-3"
                    auto-select-first
                    no-data-text="Registro não encontrado."
                    @change="changePrioridade"
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.IdGravidade"
                    :items="gravidades"
                    item-text="Gravidade"
                    item-value="IdGravidade"
                    menu-props="auto"
                    label="Gravidade"
                    hide-details
                    prepend-icon="outlined_flag"
                    class="mb-3"
                    auto-select-first
                    clearable
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.IdUrgencia"
                    :items="urgencias"
                    item-text="Urgencia"
                    item-value="IdUrgencia"
                    menu-props="auto"
                    label="Urgência"
                    hide-details
                    prepend-icon="outlined_flag"
                    class="mb-3"
                    auto-select-first
                    clearable
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.IdTendencia"
                    :items="tendencias"
                    item-text="Tendencia"
                    item-value="IdTendencia"
                    menu-props="auto"
                    label="Tendência"
                    hide-details
                    prepend-icon="outlined_flag"
                    class="mb-3"
                    auto-select-first
                    clearable
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                  <v-autocomplete
                    :disabled="!permiteAlterar"
                    v-model="atividade.ValorNps"
                    :items="valoresNps"
                    menu-props="auto"
                    label="NPS"
                    hide-details
                    prepend-icon="grade"
                    class="mb-3"
                    auto-select-first
                    clearable
                    no-data-text="Registro não encontrado."
                  ></v-autocomplete>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>

      <!-- Observações -->
      <v-tab-item>
        <v-container fluid px-3>
          <v-layout column>
            <v-flex xs12>
              <v-card>
                <v-card-title class="py-0">
                  <span class="subheading font-weight-medium">Observações</span>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <v-btn
                      icon
                      slot="activator"
                      @click="mostraInputObservacoes = !mostraInputObservacoes"
                    ><v-icon>{{ iconInputObservacoes }}</v-icon>
                    </v-btn>
                    <span>Editar</span>
                  </v-tooltip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="!mostraInputObservacoes">
                  <div class="markdown-container prewrap" v-html="compileMarkdown(atividade.Observacoes)"></div>
                </v-card-text>
                <v-card-text v-else>
                  <SharedTextarea
                    :disabled="!permiteAlterar"
                    :value="atividade.Observacoes"
                    @change="v => atividade.Observacoes = v"
                    label="Observações"
                    hide-details
                    outline
                  />
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>

      <!-- Atividades -->
      <v-tab-item class="pt-2">
        <Grid
          :items="atividadeAtividades"
          :searchTerm="searchTerm"
          :loading="loading"
          :forcePagConfigDefault="false"
          :filtroAtivo="filtroAtivo"
        />
      </v-tab-item>
    </v-tabs-items>
    <PageLoading v-else />

    <!-- Modal Cliente -->
    <ModalCadastroCliente 
      v-model="modalCliente"
      :cliente="cliente"
      :clienteEndereco="clienteEndereco"
      :clienteTelefone="clienteTelefone"
      :clienteEmail="clienteEmail"
      @clienteAdicionado="clienteAdicionado"
      @telefoneAdicionado="telefoneAdicionado"
      @emailAdicionado="emailAdicionado"
      @editaTelefone="editaTelefone"
      @editaEmail="editaEmail"
      @cancelaEditaTelefone="cancelaEditaTelefone"
      @cancelaEditaEmail="cancelaEditaEmail"
      @addNewEndereco="addNewEndereco"
      @deleteEndereco="deleteEndereco"
      @deleteTelefone="deleteTelefone"
      @deleteEmail="deleteEmail"
      @changeEndereco="changeEndereco"
      @abreModalInfoProjeto="abreModalInfoProjeto"
    />
    <!-- Modal Info Projeto -->
    <ModalInfoProjeto 
      v-model="modalInfoProjeto"
      :projeto="projeto"
    />
    <!-- Modal Workflow Colaboradores -->
    <WorkflowColaboradores 
      v-model="modalWorflowColaboradores"
      :workflow="workflow"
      @workflowColaboradorSelected="workflowColaboradorSelected"
    />
    <!-- Modal Setar Previsão -->
    <ModalEditPrevisao 
      v-model="dialogPrevisao"
      :atividade="null"
      :loading="loading"
      @setaPrevisaoSelected="setaPrevisaoItemSelected"
    />
    <!-- Modal Setar Situação -->
    <ModalEditSituacao 
      v-model="dialogSituacao"
      :atividade="null"
      :loading="loading"
      @setaSituacaoSelected="setaSituacaoItemSelected"
    />
    <!-- Modal Setar Responsável -->
    <ModalEditResponsavel 
      v-model="dialogResponsavel"
      :atividade="null"
      :loading="loading"
      @setaResponsavelSelected="setaResponsavelItemSelected"
    />
    <!-- Modal Setar Tipo Atividade -->
    <ModalEditTipoAtividade 
      v-model="dialogTipoAtividade"
      :atividade="null"
      :loading="loading"
      @setaTipoAtividadeSelected="setaTipoAtividadeItemSelected"
    />
    <!-- Modal Setar Colaborador -->
    <ModalEditColaborador 
      v-model="dialogColaborador"
      :atividadeColaborador="null"
      :loading="loading"
      @setaColaboradorSelected="setaColaboradorItemSelected"
    />
    <!-- Modal Setar Cliente -->
    <ModalEditCliente 
      v-model="dialogCliente"
      :atividadeCliente="null"
      :loading="loading"
      @setaClienteSelected="setaClienteItemSelected"
    />
    <!-- Modal Setar Ocorrencia -->
    <ModalSetaOcorrencia 
      v-model="dialogOcorrencia"
      :loading="loading"
      :atividadeOcorrencia="atividadeOcorrencia"
      @setaOcorrenciaSelected="setaOcorrenciaItemSelected"
    />
    <!-- Modal Setar Tag -->
    <ModalEditTag 
      v-model="dialogTag"
      :atividadeTag="null"
      :loading="loading"
      @setaTagSelected="setaTagItemSelected"
    />
    <!-- Modal List Atividade -->
    <ModalListAtividade 
      v-model="dialogAtividadesVincular"
      :items="atividadesVincular"
      :filters="true"
      :loading="buscaAtividadesLoading"
      @input="closeModalAtividadesVincular"
      @vinculaAtividade="vinculaAtividadeSelected"
      @atualizaListaAtividadesVincular="getAtividadesVincular"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { matrizGutHelper } from '@/utils/matrizGutHelper';
import { npsHelper } from '@/utils/npsHelper';
import { atividadeService } from '@/domain/atividade/AtividadeService';
import { atividadeOcorrenciaService } from '@/domain/atividade/AtividadeOcorrenciaService';
import Atividade from '@/domain/atividade/Atividade';
import AtividadeOcorrencia from '@/domain/atividade/AtividadeOcorrencia';
import AtividadeChecklist from '@/domain/atividade/AtividadeChecklist';
import AtividadeColaborador from '@/domain/atividade/AtividadeColaborador';
import AtividadeCliente from '@/domain/atividade/AtividadeCliente';
import AtividadeTag from '@/domain/atividade/AtividadeTag';
import Cliente from '@/domain/cliente/Cliente';
import ClienteEndereco from '@/domain/cliente/ClienteEndereco';
import ClienteTelefone from '@/domain/cliente/ClienteTelefone';
import ClienteEmail from '@/domain/cliente/ClienteEmail';
import ModalCadastroCliente from '@/components/cliente/ModalCadastroCliente';
import ModalInfoProjeto from '@/components/projeto/ModalInfoProjeto';
import Projeto from '@/domain/projeto/Projeto';
import WorkflowColaboradores from '@/components/workflow/WorkflowColaboradores';
import marked from 'marked';
import Menu from '@/components/shared/Menu';
import Tabs from '@/components/shared/Tabs';
import Grid from '@/components/shared/Grid';
import ModalListAtividade from '@/components/atividade/ModalListAtividade';
import ModalEditPrevisao from '@/components/atividade/ModalEditPrevisao';
import ModalEditSituacao from '@/components/atividade/ModalEditSituacao';
import ModalEditResponsavel from '@/components/atividade/ModalEditResponsavel';
import ModalEditColaborador from '@/components/atividade/ModalEditColaborador';
import ModalEditTipoAtividade from '@/components/atividade/ModalEditTipoAtividade';
import ModalEditCliente from '@/components/atividade/ModalEditCliente';
import ModalEditTag from '@/components/atividade/ModalEditTag';
import ModalSetaOcorrencia from '@/components/atividade/ModalSetaOcorrencia';
import SharedTextarea from '@/components/shared/Textarea';

export default {
  name: 'CadastroAtividade',
  components: {
    ModalCadastroCliente,
    ModalInfoProjeto,
    WorkflowColaboradores,
    Menu,
    Tabs,
    Grid,
    ModalListAtividade,
    ModalEditPrevisao,
    ModalEditSituacao,
    ModalEditResponsavel,
    ModalEditColaborador,
    ModalEditTipoAtividade,
    ModalEditCliente,
    ModalEditTag,
    ModalSetaOcorrencia,
    SharedTextarea,
  },
  data() {
    return {
      fromRoute: null,
      loadingPage: true,
      id: this.$route.params.id || null,
      atividade: new Atividade(),
      atividadeOcorrencia: new AtividadeOcorrencia(),
      atividadeOcorrenciaOriginal: new AtividadeOcorrencia(),
      editAtividadeOcorrencia: new AtividadeOcorrencia(),
      atividadeChecklist: new AtividadeChecklist(),
      atividadeChecklistOriginal: new AtividadeChecklist(),
      editAtividadeChecklist: new AtividadeChecklist(),
      atividadeColaborador: new AtividadeColaborador(),
      atividadeCliente: new AtividadeCliente(),
      atividadeTag: new AtividadeTag(),
      atividadeClientes: [],
      atividadeTags: [],
      atividadeColaboradores: [],
      atividadeProjetos: [],
      atividadeAtividades: [],
      atividadeOcorrencias: [],
      atividadeChecklists: [],
      formTitle: 'Atividade',
      inputOcorrencia: false,
      inputChecklist: false,
      editandoChecklist: null,
      valid: true,
      validOcorrencia: true,
      checkbox: false,
      ocorrenciaDatepicker: false,
      editOcorrenciaDatepicker: false,
      atividadeDatepicker: false,
      timepicker: false,
      editOcorrenciaTimepicker: false,
      editandoOcorrencia: null,
      dataPrevisao: new Date().toISOString().substr(0, 10),
      dataOcorrencia: new Date().toISOString().substr(0, 10),
      horario: '00:00',
      duracao: '00:01',
      loadingAtividade: false,
      loadingChecklist: false,
      loadingOcorrencia: false,
      dialogClientInfo: false,
      loadingInfoClient: false,
      hideLogOcorrencias: false,
      mostraInputObservacoes: false,
      timeout: null,
      showSearch: false,
      searchTerm: '',
      filtroAtivo: 'Todas',
      menuItems: [
        { descricao: 'Voltar Status', action: 'voltaStatus', icon: 'undo' }
      ],
      // Tabs
      tab: 0,
      tabsHeader: ['Dados', 'Observações', 'Atividades'],
      // Modal Vincular Atividades
      atividadesVincular: [],
      dialogAtividadesVincular: false,
      buscaAtividadesLoading: false,
      // Modal Cliente
      loading: false,
      modalCliente: false,
      cliente: new Cliente(),
      clienteEndereco: new ClienteEndereco(),
      clienteTelefone: new ClienteTelefone(),
      clienteEmail: new ClienteEmail(),
      // Modal Info Projeto
      modalInfoProjeto: false,
      projeto: new Projeto(),
      // Modal Worflow colaboradores
      modalWorflowColaboradores: false,
      workflow: null,
      modeloOcorrencia: null,
      // Modals
      dialogPrevisao: false,
      dialogSituacao: false,
      dialogResponsavel: false,
      dialogTipoAtividade: false,
      dialogColaborador: false,
      dialogCliente: false,
      dialogTag: false,
      dialogOcorrencia: false,
      // Permite alterar
      permiteAlterar: true,
      gravidades: [
        { IdGravidade: 1, Gravidade: 'SEM GRAVIDADE' },
        { IdGravidade: 2, Gravidade: 'POUCO GRAVE' },
        { IdGravidade: 3, Gravidade: 'GRAVE' },
        { IdGravidade: 4, Gravidade: 'MUITO GRAVE' },
        { IdGravidade: 5, Gravidade: 'EXTREMAMENTE GRAVE' }
      ],
      urgencias: [
        { IdUrgencia: 1, Urgencia: 'LONGO PRAZO' },
        { IdUrgencia: 2, Urgencia: 'BASTANTE PRAZO' },
        { IdUrgencia: 3, Urgencia: 'MÉDIO PRAZO' },
        { IdUrgencia: 4, Urgencia: 'CURTO PRAZO' },
        { IdUrgencia: 5, Urgencia: 'O QUANTO ANTES' }
      ],
      tendencias: [
        { IdTendencia: 1, Tendencia: 'NÃO PIORA' },
        { IdTendencia: 2, Tendencia: 'PIORA AO LONGO PRAZO' },
        { IdTendencia: 3, Tendencia: 'PIORA AO MÉDIO PRAZO' },
        { IdTendencia: 4, Tendencia: 'PIORA AO CURTO PRAZO' },
        { IdTendencia: 5, Tendencia: 'PIORA RAPIDAMENTE' }
      ],
      valoresNps: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      focusTextareaOcorrencia: false
    }
  },
  methods: {
    ...mapMutations(['showNotification', 'closeNotification']),
    ...mapActions([
      'resetAtividadeState',
      'addAtividade', 
      'fetchAtividadeById',
      'fetchAtividadeByIdNode',
      'updateAtividade', 
      'updateAtividadeNode', 
      'finalizarAtividade',
      'finalizarAtividadeNode',
      'voltarStatusAtividade',
      'fetchOcorrencias', 
      'fetchOcorrenciasNode', 
      'addOcorrencia', 
      'addOcorrenciaNode', 
      'updateOcorrencia',
      'updateOcorrenciaNode',
      'deleteOcorrencia', 
      'deleteOcorrenciaNode', 
      'fetchTags', 
      'fetchAtividadeTags', 
      'addAtividadeTag', 
      'deleteAtividadeTag',
      'fetchAtividadeColaboradores',
      'fetchAtividadeColaboradoresNode',
      'addAtividadeColaborador',
      'addAtividadeColaboradorNode',
      'deleteAtividadeColaborador',
      'deleteAtividadeColaboradorNode',
      'fetchChecklists',
      'fetchChecklistsNode',
      'addChecklist',
      'addChecklistNode',
      'updateChecklist',
      'updateChecklistNode',
      'deleteChecklist',
      'deleteChecklistNode',
      'fetchClientes',
      'fetchAtividadeClientes',
      'fetchAtividadeClientesNode',
      'fetchClienteById',
      'addCliente',
      'addClienteNode',
      'addClienteAtividadeSelectedNode',
      'deleteCliente',
      'deleteClienteNode',
      'fetchSituacoesAtividade',
      'fetchColaboradores',
      'fetchPrioridades',
      'fetchTiposAtividade',
      'fetchTiposOcorrencia',
      'fetchAtividadeProjetosNode',
      'deleteClienteEndereco',
      'deleteClienteTelefone',
      'deleteClienteEmail',
      'fetchClienteEnderecos',
      'fetchClienteTelefones',
      'fetchClienteEmails',
      'fetchProjetoById',
      'fetchItensProjetosNode',
      'fetchClienteTags',
      'fetchClienteProjetos',
      'fetchEquipeColaboradores',
      'fetchWorkflows',
      'fetchModelosOcorrencia',
      'addAtividadeVinculo',
      'deleteAtividadeVinculo',
      'resetAtividadesSelected',
      'deleteAtividadeNode',
    ]),

    abreModalSetaOcorrencia(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogOcorrencia = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a ocorrência.', status: 'error' });
      }
    },

    async setaOcorrenciaItemSelected(ocorrencia) {
      if (this.atividadesSelected.length) {
        this.loading = true;

        for (const atividade of this.atividadesSelected) {
          ocorrencia.IdAtividade = atividade.IdAtividade;
          await this.addOcorrenciaNode(ocorrencia);
        }
        this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
        this.dialogOcorrencia = false;
        this.resetAtividadesSelected();
        this.atividadeOcorrencia = new AtividadeOcorrencia();
        this.loading = false;
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a ocorrência.`, status: 'error' });
      }
    },

    abreModalEditTag(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogTag = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a tag.', status: 'error' });
      }
    },

    setaTagItemSelected(tag) {
      if (this.atividadesSelected.length) {
        this.loadgin = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeTag = new AtividadeTag();
          atividadeTag.IdAtividade = item.IdAtividade;
          atividadeTag.IdTag = tag.IdTag || null;
          atividadeTag.Descricao = tag.Descricao || tag;
          promises.push(this.addAtividadeTag(atividadeTag));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTag = false;
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.loadgin = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a tag.`, status: 'error' });
      }
    },

    abreModalEditCliente(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogCliente = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o cliente.', status: 'error' });
      }
    },

    setaClienteItemSelected(cliente) {
      if (this.atividadesSelected.length) {
        this.loading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeCliente = new AtividadeCliente();
          atividadeCliente.IdAtividade = item.IdAtividade;
          atividadeCliente.IdCliente = cliente.IdCliente;
          atividadeCliente.Fantasia = cliente.Fantasia;
          promises.push(this.addClienteAtividadeSelectedNode(atividadeCliente));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogCliente = false;
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.loading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o cliente.`, status: 'error' });
      }
    },

    abreModalEditColaborador(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogColaborador = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o colaborador.', status: 'error' });
      }
    },

    setaColaboradorItemSelected(colaborador) {
      if (this.atividadesSelected.length) {
        this.loading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          let atividadeColaborador = new AtividadeColaborador();
          atividadeColaborador.IdAtividade = item.IdAtividade;
          atividadeColaborador.IdColaborador = colaborador.IdColaborador;
          atividadeColaborador.Colaborador = colaborador.Descricao;
          promises.push(this.addAtividadeColaboradorNode(atividadeColaborador));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogColaborador = false;
            this.resetAtividadesSelected();
            this.loading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o colaborador.`, status: 'error' });
      }
    },

    abreModalEditTipoAtividade(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogTipoAtividade = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o tipo.', status: 'error' });
      }
    },

    setaTipoAtividadeItemSelected(tipoAtividade) {
      if (this.atividadesSelected.length) {
        this.setaTipoAtividadeLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdTipoAtividade = tipoAtividade.IdTipoAtividade;
          atividade.TipoAtividade = tipoAtividade.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogTipoAtividade = false;
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.setaTipoAtividadeLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o tipo.`, status: 'error' });
      }
    },

    abreModalEditResponsavel(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogResponsavel = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar o responsável.', status: 'error' });
      }
    },

    setaResponsavelItemSelected(responsavel) {
      if (this.atividadesSelected.length) {
        this.setaResponsavelLoading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdResponsavel = responsavel.IdColaborador;
          atividade.Responsavel = responsavel.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogResponsavel = false;
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.setaResponsavelLoading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar o responsável.`, status: 'error' });
      }
    },

    abreModalEditSituacao(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogSituacao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a situação.', status: 'error' });
      }
    },

    setaSituacaoItemSelected(situacao) {
      if (this.atividadesSelected.length) {
        this.loading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.IdSituacao = situacao.IdSituacao;
          atividade.Situacao = situacao.Descricao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.dialogSituacao = false;
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.loading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a situação.`, status: 'error' });
      }
    },
    
    abreModalEditPrevisao(atividade) {
      if (this.atividadesSelected.length) {
        this.dialogPrevisao = true;
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para setar a previsão.', status: 'error' });
      }
    },

    setaPrevisaoItemSelected(previsao) {
      if (this.atividadesSelected.length) {
        this.loading = true;
        let promises = [];

        this.atividadesSelected.forEach(item => {
          const atividade = { ...item };
          atividade.DataPrevisao = previsao;
          promises.push(this.updateAtividadeNode(atividade));
        });

        Promise.all(promises)
          .then(() => {
            this.resetAtividadesSelected();
            this.getAtividadeAtividades();
            this.dialogPrevisao = false;
            this.loading = false;
          });
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para setar a previsão.`, status: 'error' });
      }
    },

    voltaStatusItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja voltar o status de: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.voltarStatusAtividade(item.IdAtividade)));
          Promise.all(promises)
            .then(() => {
              this.resetAtividadesSelected();
              this.getAtividadeAtividades();
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para voltar o status.', status: 'error' });
      }
    },

    finalizaItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja finalizar: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.finalizarAtividadeNode(item)));
          Promise.all(promises)
            .then(() => {
              this.resetAtividadesSelected();
              this.getAtividadeAtividades();
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para finalizar.', status: 'error' });
      }
    },

    deleteItemSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja excluir: ${this.atividadesSelected.length} registros?`)) {
          let promises = [];

          this.atividadesSelected.forEach(item => promises.push(this.deleteAtividadeNode(item.IdAtividade)));
          Promise.all(promises)
            .then(() => {
              this.resetAtividadesSelected();
              this.getAtividadeAtividades();
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos uma atividade para excluir.', status: 'error' });
      }
    },

    editItemSelected() {
      if (this.atividadesSelected.length) {
        let id = this.atividadesSelected[this.atividadesSelected.length - 1].IdAtividade;
        this.$router.push({ name: 'altera atividade', params: { id } });
        this.resetAtividadesSelected();
      } else {
        this.showNotification({ text: 'Selecione uma atividade para alterar.', status: 'error' });
      }
    },

    removerVinculoAtividade() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja remover o vínculo de ${this.atividadesSelected.length} atividades?`)) {
          let promises = [];
    
          this.atividadesSelected.forEach(atividade => {
            const atividadeVinculo = {
              IdAtividadeVinculo: this.id,
              IdAtividade: atividade.IdAtividade
            }
            promises.push(this.deleteAtividadeVinculo(atividadeVinculo));
          });
    
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
              this.resetAtividadesSelected();
              this.getAtividadeAtividades();
            })
            .catch(error => {
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao remover o vinculo da atividade: ${error}`, status: 'error' });
            });
        }
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para remover o vinculo.`, status: 'error' });
      }
    },
    

    vinculaAtividadeSelected() {
      if (this.atividadesSelected.length) {
        if (confirm(`Tem certeza que deseja vincular ${this.atividadesSelected.length} atividade(s) à atividade: ${this.atividade.Descricao}`)) {
          this.buscaAtividadesLoading = true;

          let promises = [];

          this.atividadesSelected.forEach(atividade => {
            let atividadeVincular = {
              IdAtividadeVinculo: this.id,
              IdAtividade: atividade.IdAtividade
            }

            promises.push(this.addAtividadeVinculo(atividadeVincular));
          });

          Promise.all(promises)
            .then(async () => {
              await this.getAtividadeAtividades();
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
              this.dialogAtividadesVincular = false;
              this.resetAtividadesSelected();
              this.atividadesVincular = [];
              this.buscaAtividadesLoading = false;
            })
            .catch(error => {
              this.buscaAtividadesLoading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao vincular as atividades: ${error}`, status: 'error' });
            });
        }
      } else {
        this.showNotification({ text: `Selecione pelo menos uma atividade para vincular.`, status: 'error' });
      }
    },

    async getAtividadesVincular(payload) {
      this.buscaAtividadesLoading = true;

      try {
        const params = {
          status: payload.status,
          idTipoAtividade: payload.idTipoAtividade,
          idResponsavel: this.user.IdColaborador,
          dataInicial: payload.dataInicial,
          dataFinal: payload.dataFinal,
          idAtividade: this.id
        };

        const response = await atividadeService.getAtividadesVincular(params);
        this.atividadesVincular = response.data;
        this.buscaAtividadesLoading = false;
      } catch (error) {
        this.buscaAtividadesLoading = false;
        this.showNotification({ text: `Ocorreu um erro ao buscar as atividades para vincular: ${error}`, status: 'error' });
      }
    },

    tabChanged(t) {
      this.tab = t;
    },
    
    search(term) {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.searchTerm = !!term ? term : '';
      }, 500);
    },

    async voltaStatusItem() {
      if (confirm(`Tem certeza que deseja voltar o status da atividade: ${this.atividade.Descricao}?`)) {
        this.loadingPage = true;
        await this.voltarStatusAtividade(this.atividade.IdAtividade);
        await this.getAndInitializeAtividade();
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },

    changeModeloOcorrencia(obj) {
      if (this.editAtividadeOcorrencia.IdAtividade) {
        this.editAtividadeOcorrencia.TipoOcorrencia = obj.TipoOcorrencia;
        this.editAtividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
        this.editAtividadeOcorrencia.Descricao = obj.Ocorrencia;
        this.duracao = this.duracaoItem(obj.Duracao);
      } else {
        this.atividadeOcorrencia.TipoOcorrencia = obj.TipoOcorrencia;
        this.atividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
        this.atividadeOcorrencia.Descricao = obj.Ocorrencia;
        this.duracao = this.duracaoItem(obj.Duracao);
      }
    },

    compileMarkdown(text) {
      return text ? marked(text) : '';
    },

    corStatus(status) {
      if (status.startsWith('A')) return "#263238";
      if (status.startsWith('F')) return "#1976d2";
      if (status.startsWith('C')) return "#bdbdbd";
    },

    progressColor(progresso) {
      if (progresso >= 0 && progresso <= 30) return 'error'
      if (progresso >= 30 && progresso < 100) return 'warning'
      if (progresso == 100) return 'success'
    },

    matrizGutColor(valor) {
      return matrizGutHelper.matrizGutColor(valor);
    },

    npsValue(valor) {
      return npsHelper.npsValue(valor);
    },

    npsColor(valor) {
      return npsHelper.npsColor(valor);
    },

    primeiroNome(nome) {
      return nome.split(' ').slice(0, 1).join('');
    },

    async changeResponsavel(obj) {
      this.atividade.Responsavel = obj.Descricao;
      this.atividade.IdResponsavel = obj.IdColaborador;
      // Verifica se o novo colaborador responsável tem equipe cadastrada
      // Caso sim faz uma pergunta para adicionar os colaboradores da equipe
      if (this.colaboradorTemEquipe(obj)) {
        if (confirm(`Deseja adicionar os colaboradores da equipe: ${obj.Equipe} à atividade?`)) {
          const colaboradoresEquipe = await this.fetchEquipeColaboradores(obj.IdEquipe);
          if (colaboradoresEquipe && colaboradoresEquipe.length) {
            for (const colaborador of colaboradoresEquipe) {
              if (!this.colaboradorJaInteressado(colaborador)) {
                await this.changeColaborador(colaborador);
              }
            }
          } else {
            this.showNotification({ text: `Equipe: ${obj.Equipe} não contém colaboradores.`, status: 'error' });
          }
        }
      }
      // Verifica se o usuário atual já está adicionado como interessado e não é o responsável atual
      // Caso não faz uma pergunta para adicionar o usuário atual como interessado
      if (!this.colaboradorJaInteressado(this.user) && obj.IdColaborador != this.user.IdColaborador) {
        if (confirm('Deseja ser adicionado como interessado dessa atividade?')) {
          await this.changeColaborador(this.user);
        }
      }
    },

    changeTipoAtividade(obj) {
      this.atividade.TipoAtividade = obj.Descricao;
      this.atividade.IdTipoAtividade = obj.IdTipoAtividade;
    },

    changeWorkflow(obj) {
      if (obj && typeof obj === 'object') {
        this.atividade.Workflow = obj.Descricao;
        this.atividade.IdWorkflow = obj.IdWorkflow;
        this.workflow = Object.assign({}, obj);
        this.modalWorflowColaboradores = true;
      } else {
        this.atividade.Workflow = '';
        this.atividade.IdWorkflow = undefined;
        this.workflow = null;
      }
    },

    workflowColaboradorSelected(colaborador) {
      if (confirm(`Deseja setar: ${colaborador.Colaborador} como responsável da atividade?`)) {
        const { IdColaborador, Colaborador } = colaborador;
        this.changeResponsavel({ IdColaborador, Descricao: Colaborador });
        this.modalWorflowColaboradores = false;
        this.workflow = null;
      }
    },

    async changeTag(obj) {
      if (obj !== null) {
        this.atividadeTag.IdAtividade = this.atividade.IdAtividade;
        this.atividadeTag.Descricao = obj.Descricao;
        this.atividadeTag.IdTag = obj.IdTag;

        try {
          await atividadeService.addAtividadeTag(this.atividadeTag);
          this.atividadeTags.push(this.atividadeTag);
          this.atividadeTag = new AtividadeTag();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' })
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' })
        }
  
        // await this.addAtividadeTag(this.atividadeTag);
        // this.atividadeTag = new AtividadeTag();
      }
    },

    changeTipoOcorrencia(obj) {
      if (this.editAtividadeOcorrencia.IdAtividade) {
        this.editAtividadeOcorrencia.TipoOcorrencia = obj.Descricao;
        this.editAtividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
      } else {
        this.atividadeOcorrencia.TipoOcorrencia = obj.Descricao;
        this.atividadeOcorrencia.IdTipoOcorrencia = obj.IdTipoOcorrencia;
      }
    },

    async excluiTag(tag) {
      if (confirm(`Remover: ${tag.Descricao}?`)) {
        try {
          await atividadeService.deleteAtividadeTag(tag);
          this.atividadeTags = this.atividadeTags.filter(t => t.IdTag !== tag.IdTag);
          this.showNotification({ text: `Tag removida com sucesso.`, status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
        // this.deleteAtividadeTag(tag)
        //   .then(() => this.showNotification({ text: `Tag excluida com sucesso.`, status: 'success' }))
        //   .catch(error => this.showNotification({ text: `Ocorreu um erro ao excluir a tag: ${error}`, status: 'error' }));
      }
    },

    changeOcorrenciaDatepicker() {
      if (this.editOcorrenciaDatepicker) {
        this.editAtividadeOcorrencia.DataOcorrencia = this.dataOcorrencia;
        this.editOcorrenciaDatepicker = false;
      } else {
        this.atividadeOcorrencia.DataOcorrencia = this.dataOcorrencia;
        this.ocorrenciaDatepicker = false;
      }
    },

    changeAtividadeDatepicker() {
      // this.atividade.DataPrevisao = this.dataPrevisao;
      this.atividadeDatepicker = false;
      // console.log(this.atividade.DataPrevisao);
    },

    async changeColaborador(obj) {
      if (obj !== null && typeof obj == 'object') {
        this.atividadeColaborador.IdAtividade = this.atividade.IdAtividade;
        this.atividadeColaborador.Colaborador = obj.Descricao || obj.Colaborador;
        this.atividadeColaborador.IdColaborador = obj.IdColaborador;

        try {
          await atividadeService.addAtividadeColaborador(this.atividadeColaborador);
          this.atividadeColaboradores.push(this.atividadeColaborador);
          this.atividadeColaborador = new AtividadeColaborador();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' })
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' })
        }

        // await this.addAtividadeColaboradorNode(this.atividadeColaborador);
        // this.atividadeColaborador = new AtividadeColaborador();
      }
    },

    async excluiColaborador(colaborador) {
      if (confirm(`Remover: ${colaborador.Colaborador}?`)) {
        try {
          await atividadeService.deleteAtividadeColaborador(colaborador);
          this.atividadeColaboradores = this.atividadeColaboradores.filter(c => c.IdColaborador !== colaborador.IdColaborador);
          this.showNotification({ text: `Colaborador removido com sucesso.`, status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }

        // this.deleteAtividadeColaboradorNode(colaborador)
        //   .then(() => this.showNotification({ text: `Colaborador excluido com sucesso.`, status: 'success' }))
        //   .catch(error => this.showNotification({ text: `Ocorreu um erro ao excluir o colaborador: ${error}`, status: 'error' }));
      }
    },

    async changeClientes(obj) {
      if (obj !== null && typeof obj == 'object') {
        this.atividadeCliente.IdAtividade = this.atividade.IdAtividade;
        this.atividadeCliente.Fantasia = obj.Fantasia;
        this.atividadeCliente.IdCliente = obj.IdCliente;

        try {
          await atividadeService.addAtividadeCliente(this.atividadeCliente);
          this.atividadeClientes.push(this.atividadeCliente);
          this.atividadeCliente = new AtividadeCliente();
          this.showNotification({ text: 'Operação concluída com sucesso.', status: 'success' })
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' })
        }

        // await this.addClienteNode(this.atividadeCliente)
        // this.atividadeCliente = new AtividadeCliente();
      }
    },

    async excluiCliente(cliente) {
      if (confirm(`Remover: ${cliente.Fantasia}?`)) {
        try {
          await atividadeService.deleteAtividadeCliente(cliente);
          this.atividadeClientes = this.atividadeClientes.filter(c => c.IdCliente !== cliente.IdCliente);
          this.showNotification({ text: `Cliente removido com sucesso.`, status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }

        // this.deleteClienteNode(cliente)
        //   .then(() => this.showNotification({ text: `Cliente removido com sucesso.`, status: 'success' }))
        //   .catch(error => this.showNotification({ text: `Ocorreu um erro ao excluir o cliente: ${error}`, status: 'error' }));
      }
    },

    changeSituacao(obj) {
      this.atividade.Situacao = obj.Descricao;
      this.atividade.IdSituacao = obj.IdSituacao;
    },
    
    changePrioridade(obj) {
      this.atividade.Prioridade = obj.Descricao;
      this.atividade.IdPrioridade = obj.IdPrioridade;
    },

    calculaDuracaoOcorrencia(dataOcorrencia) {
      let inicio = this.moment(new Date(1970, 0, 1, 0, 0, 0));
      // Calcula duração entre o início da ocorrencia e agora
      let dtOcorrencia = this.moment(dataOcorrencia);
      let fim = this.moment();
      let diferencaDuration = this.moment.duration(fim.diff(dtOcorrencia));
      // Cria data final somando a duração total com a data inicio
      let duracaoFinal = inicio.add(diferencaDuration).toDate();
      this.duracao = this.duracaoItem(duracaoFinal);
    },

    buscaOcorrenciaExecucaoPendente() {
      const userOcorrencias = this.atividadeOcorrencias.filter(ocorrencia => ocorrencia.IdColaborador == this.user.IdColaborador);
      return userOcorrencias.find(ocorrencia => ocorrencia.Status.startsWith('P'));
    },

    existeOcorrenciaPendente() {
      if (this.atividadeOcorrencia.Descricao || this.editAtividadeOcorrencia.IdOcorrencia) {
        return true;
      } else {
        return false;
      }
    },

    existeOcorrenciaExecucaoPendente() {
      const ocorrenciaPendente = this.buscaOcorrenciaExecucaoPendente();
      return ocorrenciaPendente ? true : false;
    },

    async iniciaExecucaoAtividade() {
      if (confirm('Tem certeza que deseja iniciar a execução dessa atividade?')) {
        try {
          await atividadeService.iniciarAtividade(this.id);
          const resAtividadeOcorrencias = await atividadeService.getAtividadeOcorrencias(this.id);
          this.atividadeOcorrencias = resAtividadeOcorrencias.data.reverse();
          this.showNotification({ text: 'Atividade iniciada com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada.', status: 'error' });
      }
    },

    async paraExecucaoAtividade() {
      if (confirm('Deseja parar a execução dessa atividade?')) {
        const ocorrencia = this.buscaOcorrenciaExecucaoPendente();
        try {
          await atividadeService.pausarAtividade(ocorrencia.IdAtividade, ocorrencia.IdOcorrencia);
          const resAtividadeOcorrencias = await atividadeService.getAtividadeOcorrencias(this.id);
          this.atividadeOcorrencias = resAtividadeOcorrencias.data.reverse();
          this.showNotification({ text: 'Operação realizada com sucesso', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Operação cancelada', status: 'error' });
      }
    },

    async finalizaExecucaoAtividade() {
      if (confirm('Deseja finalizar a execução dessa atividade?')) {
        const ocorrencia = this.buscaOcorrenciaExecucaoPendente();
        this.editaOcorrencia(ocorrencia);
      } else {
        this.showNotification({ text: 'Operação cancelada', status: 'error' });
      }
    },

    async save() {
      // Verifica se o usuário tem permissão para alterar o recurso
      // Caso contrário retorna para a rota anterior
      if (!this.permiteAlterar) { 
        // this.resetAtividadeState();
        return this.$router.go(-1);
      }

      if (this.$refs.formAtividade.validate()) {
        // Verifica se existe ocorrência pendente
        if (this.existeOcorrenciaPendente()) {
          if (confirm('Existe ocorrência pendente! Deseja adicioná-la?')) {
            if (this.atividadeOcorrencia.IdTipoOcorrencia == 3 || this.editAtividadeOcorrencia.IdTipoOcorrencia == 3) {
              await this.adicionaOcorrencia();
              return;
            }
            await this.adicionaOcorrencia();
          }
        }
  
        localStorage.setItem('hideLogOcorrencias', this.hideLogOcorrencias);
        delete this.atividade.Duracao;
        this.loadingAtividade = true;
        const [ano, mes, dia] = this.dataPrevisao.split('-');
        this.atividade.DataPrevisao = new Date(ano, mes - 1, dia);
        this.atividade.Progresso = this.atividadeProgresso;
        this.atividade.Acao = 'MarcaNotificacoesLida';
  
        if (this.id) {
          try {
            await this.updateAtividadeNode(this.atividade);
            this.loadingAtividade = false;
            this.$router.go(-1);
            this.showNotification({ text: `Atividade: ${this.atividade.Descricao} atualizada com sucesso.`, status: 'success' });
            // this.resetAtividadeState();
          } catch (error) {
            const text = error.response.data.error;
            this.loadingAtividade = false;
            this.showNotification({ text, status: 'error' });
          }
        } else {
          this.addAtividade(this.atividade)
            .then(() => {
              this.loadingAtividade = false;
              // this.$router.push({ name: 'atividades' });
              this.$router.go(-1);
              this.showNotification({ text: `Atividade: ${this.atividade.Descricao} adicionada com sucesso.`, status: 'success' });
              // this.resetAtividadeState();
            })
            .catch(error => {
              const text = error.response.data.error;
              this.loadingAtividade = false;
              this.showNotification({ text, status: 'error' });
            });
        }
      }
    },

    // Ocorrências
    mostraInputOcorrencia() {
      this.inputOcorrencia = true;
      this.horario = `${new Date().getHours()}:${new Date().getMinutes()}`;
      this.$nextTick(() => document.getElementById('ocorrencia-add').focus());
    },

    async adicionaOcorrencia() {
        // Update Ocorrência
      if (this.editAtividadeOcorrencia.IdOcorrencia && this.editAtividadeOcorrencia.Descricao) {
        this.loadingOcorrencia = true;
        // Verifica se a duração é valida
        if (this.duracao.length < 5) this.duracao = '00:01';
        this.atividadeOcorrencia = this.editAtividadeOcorrencia;
        this.atividadeOcorrencia.IdAtividade = this.atividade.IdAtividade;
        this.atividadeOcorrencia.IdColaborador = this.user.IdColaborador;
        this.atividadeOcorrencia.Colaborador = this.user.Colaborador;
        
        // Quando a ocorrência que estiver sendo editado for a de status pendente
        // Adiciona a Ação para finalizar a ocorrência.
        if (this.atividadeOcorrencia.Status.startsWith('P')) this.atividadeOcorrencia.Acao = 'FinalizaAtividadeOcorrencia';
        
        // Se acontecer de alguem editar um ocorrencia de status normal e mudar para o tipo finalização
        // e existir ocorrencia de execução pendente sera finalizado a execução, porém, as 2 ocorrencias
        // Vão ficar com a mesma descrição, nesse caso não vou deixar editar para o tipo finalização
        // quando existir uma ocorrencia de execução pendente
        // if (this.atividadeOcorrencia.IdTipoOcorrencia == 3 && this.existeOcorrenciaExecucaoPendente()) this.atividadeOcorrencia.Acao = 'FinalizaAtividadeOcorrencia';
        
        const minutoDuracao = `${this.duracao[3]}${this.duracao[4]}`;
        const horaDuracao = `${this.duracao[0]}${this.duracao[1]}`;
        this.atividadeOcorrencia.Duracao = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracao, 'h').add(minutoDuracao, 'm').toDate();
        
        const updOcorrencia = { ...this.atividadeOcorrencia };

        try {
          const response = await atividadeService.updateAtividadeOcorrencia(updOcorrencia);
          updOcorrencia.Status = response.data.Status;
          this.editandoOcorrencia = null;
          this.atividadeOcorrenciaOriginal = {};
          this.atividadeOcorrencia = new AtividadeOcorrencia();
          this.editAtividadeOcorrencia = new AtividadeOcorrencia();
          this.dataOcorrencia = new Date().toISOString().substr(0, 10);
          this.horario = `${new Date().getHours()}:${new Date().getMinutes()}`;
          this.duracao = '00:00';
          this.inputOcorrencia = false;
          this.loadingOcorrencia = false;
          const index = this.atividadeOcorrencias.findIndex(ocorrencia => ocorrencia.IdOcorrencia === updOcorrencia.IdOcorrencia);
          if (index !== -1) {
            this.atividadeOcorrencias.splice(index, 1, updOcorrencia);
          }

          if (updOcorrencia.IdTipoOcorrencia === 3) {
            this.atividadeOcorrencia = new AtividadeOcorrencia();
            this.editAtividadeOcorrencia = new AtividadeOcorrencia();
            this.atividade.Status = 'F';
            this.atividade.IdSituacao = 39;
            await this.save();
          }

          this.showNotification({ text: 'Ocorrencia atualizada com sucesso.', status: 'success' });
        } catch (error) {
          this.loadingOcorrencia = false;
          const text = error.response.data.error;
          this.showNotification({ text, status: 'error' });
        }
      // Add Ocorrência
      } else if (!this.editAtividadeOcorrencia.IdOcorrencia && this.$refs.formOcorrencia.validate()) {
        this.loadingOcorrencia = true;
        this.atividadeOcorrencia.IdAtividade = this.atividade.IdAtividade;
        this.atividadeOcorrencia.IdColaborador = this.user.IdColaborador;
        this.atividadeOcorrencia.Colaborador = this.user.Colaborador;

        // Quando a ocorrência que estiver sendo editado for a de status pendente
        // Adiciona a Ação para finalizar a ocorrência.
        if (this.existeOcorrenciaExecucaoPendente() && this.atividadeOcorrencia.IdTipoOcorrencia == 3) this.atividadeOcorrencia.Acao = 'FinalizaAtividadeOcorrencia';
        
        const minutoDuracao = `${this.duracao[3]}${this.duracao[4]}`;
        const horaDuracao = `${this.duracao[0]}${this.duracao[1]}`;
        this.atividadeOcorrencia.Duracao = this.moment(new Date(1970, 0, 1, 0, 0, 0)).add(horaDuracao, 'h').add(minutoDuracao, 'm').toDate();

        const newOcorrencia = { ...this.atividadeOcorrencia };

        try {
          const response = await atividadeService.addAtividadeOcorrencia(newOcorrencia);
          newOcorrencia.IdOcorrencia = response.data.IdOcorrencia;
          newOcorrencia.DataOcorrencia = response.data.DataOcorrencia;
          this.atividadeOcorrencias.unshift(newOcorrencia);

          if (newOcorrencia.IdTipoOcorrencia === 3) {
            this.atividadeOcorrencia = new AtividadeOcorrencia();
            this.atividade.Status = 'F';
            this.atividade.IdSituacao = 39;
            await this.save();
          }

          this.atividadeOcorrencia = new AtividadeOcorrencia();
          this.dataOcorrencia = new Date().toISOString().substr(0, 10);
          this.horario = `${new Date().getHours()}:${new Date().getMinutes()}`;
          this.duracao = '00:00';
          this.inputOcorrencia = false;
          this.loadingOcorrencia = false;
          this.showNotification({ text: 'Ocorrência adicionada com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingOcorrencia = false;
          this.showNotification({ text, status: 'error' });
        }
      }
      this.modeloOcorrencia = null;

    },

    editaOcorrencia(ocorrencia) {
      // Guarda uma cópia original da ocorrencia
      this.atividadeOcorrenciaOriginal = Object.assign({}, ocorrencia);
      this.editandoOcorrencia = ocorrencia.IdOcorrencia;
      this.editAtividadeOcorrencia = Object.assign({}, ocorrencia);
      if (this.editAtividadeOcorrencia.Status.startsWith('P')) {
        this.editAtividadeOcorrencia.Descricao = '';
        this.calculaDuracaoOcorrencia(this.editAtividadeOcorrencia.DataOcorrencia);
      } else {
        this.editAtividadeOcorrencia.Acao = '';
        this.duracao = this.duracaoItem(this.editAtividadeOcorrencia.Duracao);
      }
      this.$nextTick(() => document.getElementById('ocorrencia-edit-item').focus());
    },

    cancelaEditaOcorrencia(ocorrencia) {
      // Retorna a ocorrência ao seu valor original antes da edição
      Object.assign(ocorrencia, this.atividadeOcorrenciaOriginal);
      this.editandoOcorrencia = null;
      this.editAtividadeOcorrencia = new AtividadeOcorrencia();
      this.dataOcorrencia = new Date().toISOString().substr(0, 10);
      this.horario = `${new Date().getHours()}:${new Date().getMinutes()}`;
      this.duracao = '00:00';
      this.showNotification({ text: 'Operação cancelada.', status: 'error' });
      // console.log(this.editAtividadeOcorrencia);
    },

    async excluiOcorrencia(ocorrencia) {
      if (confirm(`Excluir: ${ocorrencia.Descricao}?`)) {
        this.loadingOcorrencia = true;

        try {
          await atividadeService.deleteAtividadeOcorrencia(ocorrencia);  
          this.atividadeOcorrencias = this.atividadeOcorrencias.filter(o => o.IdOcorrencia !== ocorrencia.IdOcorrencia);
          this.loadingOcorrencia = false;
          this.showNotification({ text: 'Ocorrência excluída com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingOcorrencia = false;
          this.showNotification({ text, status: 'error' });
        }
      }
    },

    close() {
      this.$router.go(-1);
      this.resetAtividadeState();
    },

    // Checklists
    mostraInputChecklist() {
      this.inputChecklist = true;
      this.$nextTick(() => document.getElementById('checklist-add-item').focus());
    },

    async adicionaChecklist() {
      // Update checklist
      if (this.editAtividadeChecklist.IdChecklist) {
        this.loadingChecklist = true;
        this.atividadeChecklist = this.editAtividadeChecklist;

        if (this.atividadeChecklist.Descricao) {
          const updChecklist = { ...this.atividadeChecklist };

          try {
            const response = await atividadeService.updateAtividadeChecklist(updChecklist);
            this.editandoChecklist = null;
            this.atividadeChecklistOriginal = {};
            this.atividadeChecklist = new AtividadeChecklist();
            this.editAtividadeChecklist = new AtividadeChecklist();
            this.loadingChecklist = false;
            const index = this.atividadeChecklists.findIndex(checklist => checklist.IdChecklist === updChecklist.IdChecklist);
            if (index !== -1) {
              this.atividadeChecklists.splice(index, 1, updChecklist);
            }
            this.showNotification({ text: 'Checklist atualizado com sucesso.', status: 'success' });
          } catch (error) {
            this.loadingChecklist = false;
            const text = error.response.data.error;
            this.showNotification({ text, status: 'error' });
          }
        } else {
          this.loadingChecklist = false;
          this.showNotification({ text: 'Informe a descrição do checklist.', status: 'error' });
        }  

      // Add Checklist
      } else {
        if (this.atividadeChecklist.Descricao) {
          this.atividadeChecklist.IdAtividade = this.atividade.IdAtividade;
          const newChecklist = { ...this.atividadeChecklist };

          try {
            const response = await atividadeService.addAtividadeChecklist(newChecklist);
            newChecklist.IdChecklist = response.data.IdChecklist;
            this.atividadeChecklists.push(newChecklist);
            this.atividadeChecklist = new AtividadeChecklist();
            this.loadingChecklist = false;
            this.showNotification({ text: 'Checklist adicionado com sucesso.', status: 'success' });
            this.$nextTick(() => document.getElementById('checklist-add-item').focus());
          } catch (error) {
            this.loadingChecklist = false;
            const text = error.response.data.error;
            this.showNotification({ text, status: 'error' });
          }
        } else {
          this.loadingChecklist = false;
          this.showNotification({ text: 'Informe a descrição do checklist.', status: 'error' });
        }
      }
    },

    editaChecklist(checklist) {
      // Guarda uma cópia original do checklist
      this.atividadeChecklistOriginal = Object.assign({}, checklist);
      this.editandoChecklist = checklist.IdChecklist;
      this.editAtividadeChecklist = checklist;
      this.$nextTick(() => document.getElementById('checklist-edit-item').focus());
    },

    cancelaEditaChecklist(checklist) {
      // Retorna o checklist ao seu valor original antes da edição
      Object.assign(checklist, this.atividadeChecklistOriginal);
      this.editandoChecklist = null;
      this.editAtividadeChecklist = new AtividadeChecklist();
      this.showNotification({ text: `Operação cancelada.`, status: 'error' });
    },

    concluiChecklist(checklist) {
      this.editAtividadeChecklist = { ...checklist };
      this.adicionaChecklist();
    },

    async excluiChecklist(checklist) {
      if (confirm(`Excluir: ${checklist.Descricao}?`)) {
        this.loadingChecklist = true;

        try {
          await atividadeService.deleteAtividadeChecklist(checklist);  
          this.atividadeChecklists = this.atividadeChecklists.filter(c => c.IdChecklist !== checklist.IdChecklist);
          this.loadingChecklist = false;
          this.showNotification({ text: 'Checklist excluído com sucesso.', status: 'success' });
        } catch (error) {
          const text = error.response.data.error;
          this.loadingChecklist = false;
          this.showNotification({ text, status: 'error' });
        }
      }
    },

    duracaoItem(tempo) {
      // Verifica se o ano da tempo é 1899 == ano padrão DELPHI
      // Caso não, estaremos usando o ano padrão JavaScript == 1970
      const anoDelphi = new Date(tempo).getFullYear() == 1899;
      let inicio = anoDelphi ? this.moment([1899, 11, 30]): new Date(1970, 0, 1, 0, 0, 0);
      // console.log('Inicio:', inicio.format('DD/MM/YYYY HH:mm'));
      let final = this.moment(tempo);
      // console.log('Final:', final.format('DD/MM/YYYY HH:mm'));
      // Pega a diferença entre as datas em millisegundos
      let ms = this.moment(final, 'DD/MM/YYYY HH:mm:ss').diff(this.moment(inicio, 'DD/MM/YYYY HH:mm:ss'));
      let duration = this.moment.duration(ms);
      let duracaoFinal = Math.floor(duration.asHours()) + this.moment(ms).format(":mm");
      if (duracaoFinal.length === 4) duracaoFinal = `0${duracaoFinal}`;
      return duracaoFinal;
    },

    statusAtividade(status) {
      status = status.trim()
      if (status == 'P') return '#263238';
      if (status == 'F') return '#1976d2';
      if (status == 'C') return '#bdbdbd';
    },

    permiteAlterarExcluir(ocorrencia) {
      const { IdTipoOcorrencia, IdColaborador, Status } = ocorrencia;
      if (Status.trim() !== 'P' && IdTipoOcorrencia !== 2 && IdColaborador == this.user.IdColaborador) return true;
    },

    ocorrenciaFinal(tipoOcorrencia) {
      return tipoOcorrencia === 3 ? 'success' : '';
    },

    ordemOcorrencia(tipoOcorrencia) {
      return tipoOcorrencia === 3 ? 'order-1' : 'order-2';
    },

    existeOcorrenciaFinalizacao(idOcorrencia) {
      if (idOcorrencia) {
        const [ocorrenciaFinalizada] = this.atividadedOcorrencias.filter(ocorrencia => ocorrencia.IdTipoOcorrencia === 3);

        if (ocorrenciaFinalizada !== undefined) {
          return idOcorrencia !== ocorrenciaFinalizada.IdOcorrencia;
        } else {
          return false;
        }
      } else {
        return this.atividadeOcorrencias.filter(ocorrencia => ocorrencia.IdTipoOcorrencia === 3).length;
      }
    },

    // Modal Atividades Vincular

    async abreModalAtividadesVincular() {
      this.resetAtividadesSelected();
      this.dialogAtividadesVincular = true;
    },

    closeModalAtividadesVincular() {
      this.resetAtividadesSelected();
      this.dialogAtividadesVincular = false;
    },

    // Modal Cliente

    addNewEndereco() {
      this.clienteEndereco = Object.assign({}, new ClienteEndereco());
    },
    async deleteEmail(email) {
      if (confirm(`Desejar remover o email: ${email.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEmail(email);
          this.loading = false;
          this.clienteEmail = Object.assign({}, new ClienteEmail());
          this.showNotification({ text: 'E-mail excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o e-mail: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteTelefone(telefone) {
      if (confirm(`Desejar remover o telefone: ${telefone.Descricao}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteTelefone(telefone);
          this.loading = false;
          this.clienteTelefone = Object.assign({}, new ClienteTelefone());
          this.showNotification({ text: 'Telefone excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o telefone: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    async deleteEndereco() {
      if (this.clienteEndereco.IdCliente && this.clienteEndereco.IdItem && confirm(`Desejar excluir o endereço: ${this.clienteEndereco.Titulo}?`)) {
        this.loading = true;
        try {
          await this.deleteClienteEndereco(this.clienteEndereco);
          this.loading = false;
          this.clienteEndereco = Object.assign({}, new ClienteEndereco());
          this.showNotification({ text: 'Endereço excluído com sucesso.', status: 'success' });
        } catch (error) {
          this.loading = false;
          console.log(error);
          this.showNotification({ text: `Ocorreu um erro ao excluir o endereço atual: ${error}`, status: 'error' });
        }
      } else {
        this.showNotification({ text: `Operação cancelada.`, status: 'error' });
      }
    },
    changeEndereco(endereco) {
      this.clienteEndereco = Object.assign({}, endereco);
    },
    clienteAdicionado() {
      this.clienteInfo = Object.assign({}, new Cliente());
    },
    telefoneAdicionado() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    emailAdicionado() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaEmail(email) {
      this.clienteEmail = Object.assign({}, email);
      if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('G')) {
        this.clienteEmail.Tipo = 'GERAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('N')) {
        this.clienteEmail.Tipo = 'NFE';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('F')) {
        this.clienteEmail.Tipo = 'FINANCEIRO';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('C')) {
        this.clienteEmail.Tipo = 'COMERCIAL';
      } else if (this.clienteEmail.Tipo && this.clienteEmail.Tipo.startsWith('O')) {
        this.clienteEmail.Tipo = 'OUTROS';
      } else {
        this.clienteEmail.Tipo = 'GERAL';
      }
    },
    cancelaEditaEmail() {
      this.clienteEmail = Object.assign({}, new ClienteEmail());
    },
    editaTelefone(telefone) {
      this.clienteTelefone = Object.assign({}, telefone);
      if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('G')) {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('R')) {
        this.clienteTelefone.TipoTelefone = 'RESIDENCIAL';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('C')) {
        this.clienteTelefone.TipoTelefone = 'CELULAR';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('T')) {
        this.clienteTelefone.TipoTelefone = 'TRABALHO';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('W')) {
        this.clienteTelefone.TipoTelefone = 'WHATSAPP';
      } else if (this.clienteTelefone.TipoTelefone && this.clienteTelefone.TipoTelefone.startsWith('O')) {
        this.clienteTelefone.TipoTelefone = 'OUTROS';
      } else {
        this.clienteTelefone.TipoTelefone = 'GERAL';
      }
    },
    cancelaEditaTelefone() {
      this.clienteTelefone = Object.assign({}, new ClienteTelefone());
    },
    async infoClient(cliente) {      
      try {
        this.cliente = await this.fetchClienteById(cliente.IdCliente);
        this.modalCliente = true;
        const endereco = await this.fetchClienteEnderecos(cliente.IdCliente);
        this.clienteEndereco = Object.assign({}, endereco);
        await this.fetchClienteTelefones(cliente.IdCliente);
        await this.fetchClienteEmails(cliente.IdCliente);
        await this.fetchClienteTags(cliente.IdCliente);
        await this.fetchClienteProjetos(cliente.IdCliente);
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do cliente: ${error}.`, status: 'error' });
      }
    },
    async abreModalInfoProjeto(projeto) {
      try {
        this.projeto = await this.fetchProjetoById({ id: projeto.IdProjeto });
        await this.fetchItensProjetosNode(projeto.IdProjeto);
        this.modalInfoProjeto = true;
      } catch (error) {
        this.showNotification({ text: `Ocorreu um erro ao buscar as informações do projeto: ${error}.`, status: 'error' });
      }
    },
    // verifica se o usuário logado pode alterar a atividade
    // caso ele seja responsável, interessado ou admin
    usuarioTemPermissaoParaAlterar() {
      const ehResponsavel = this.user.IdColaborador === this.atividade.IdResponsavel;
      const ehInteressado = this.atividadeColaboradores.find(colaborador => this.user.IdColaborador === colaborador.IdColaborador) || false;
      if (ehResponsavel || ehInteressado || this.isAdmin) {
        return true;
      } else {
        return false;
      }
    },

    colaboradorJaInteressado(colaborador) {
      const colaboradorJaAdicionado = this.atividadeColaboradores.find(atividadeColaborador => atividadeColaborador.IdColaborador === colaborador.IdColaborador);
      return colaboradorJaAdicionado ? true : false;
    },

    colaboradorTemEquipe(colaborador) {
      return colaborador && colaborador.IdEquipe ? true : false;
    },

    loadSelectFields() {
      this.fetchSituacoesAtividade();
      this.fetchPrioridades();
      this.fetchColaboradores();
      this.fetchTags();
      this.fetchTiposAtividade();
      this.fetchTiposOcorrencia();
      this.fetchClientes();
      this.fetchWorkflows();
      this.fetchModelosOcorrencia();
    },

    loadAtividadeDetails() {
      atividadeService.getAtividadeClientes(this.id)
        .then(response => this.atividadeClientes = response.data);

      atividadeService.getAtividadeTags(this.id)
        .then(response => this.atividadeTags = response.data);
      
      atividadeService.getAtividadeChecklists(this.id)
        .then(response => this.atividadeChecklists = response.data);

      atividadeService.getAtividadeProjetos(this.id)
        .then(response => this.atividadeProjetos = response.data);

      atividadeService.getAtividadeAtividades(this.id)
        .then(response => this.atividadeAtividades = response.data);

      atividadeService.getAtividadeOcorrencias(this.id)
        .then(response => this.atividadeOcorrencias = response.data.reverse());
    },

    getAtividadeAtividades() {
      this.loading = true;

      atividadeService.getAtividadeAtividades(this.id)
        .then(response => {
          this.atividadeAtividades = response.data;
          this.loading = false;
        });
    },

    getAtividadeOcorrencias() {
      this.loadingOcorrencia = true;
      
      atividadeService.getAtividadeOcorrencias(this.id)
        .then(response => {
          this.atividadeOcorrencias = response.data.reverse();
          this.loadingOcorrencia = false;
        });
    },
    
    async getAndInitializeAtividade() {
      try {
        const response = await atividadeService.getAtividade(this.id);
        this.atividade = response.data[0];
        
        this.dataPrevisao = new Date(this.atividade.DataPrevisao).toISOString().substr(0, 10);

        const resAtividadeColaboradores = await atividadeService.getAtividadeColaboradores(this.id);
        this.atividadeColaboradores = resAtividadeColaboradores.data;

        this.permiteAlterar = this.usuarioTemPermissaoParaAlterar();
        if (!this.permiteAlterar && !this.isAdmin && this.fromRoute !== 'helpdesk') {
          this.showNotification({ text: 'Sem permissão para acessar essa atividade', status: 'error' });
          return this.$router.go(-1);
        }
        this.loadAtividadeDetails();
        this.loadingPage = false;
      } catch (error) {
        const text = error.response.data.error;
        this.$router.go(-1);
        this.showNotification({ text, status: 'error' });
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from.name;
    });
  },

  async created() {
    if (localStorage.getItem('hideLogOcorrencias') !== null) {
      this.hideLogOcorrencias = JSON.parse(localStorage.getItem('hideLogOcorrencias'));
    }

    if (this.id) {
      // SELECT FIELDS
      this.loadSelectFields();
      await this.getAndInitializeAtividade();
    }
  },

  destroyed() {
    this.resetAtividadeState();
  },

  watch: {
    url(value) {
      const { id } = value;

      this.loadingPage = true;
      this.id = id;
      this.tab = 0;

      this.getAndInitializeAtividade();
    }
  },

  computed: {
    ...mapGetters([
      'user',
      'isAdmin',
      'rules',
      // 'ocorrencias',
      // 'atividadeTags',
      // 'atividadeColaboradores',
      // 'checklists',
      'tagsAtivo',
      'colaboradores',
      'prioridadesAtivo',
      'situacoesAtividade',
      'tiposAtividadeAtivo',
      'clientesAtivo',
      // 'atividadeClientes',
      'tiposOcorrencia',
      // 'atividadeProjetos',
      'workflows',
      'modelosOcorrenciaAtivo',
      'atividadesSelected'
    ]),

    url() {
      const params = this.$route.params;
      return params;
    },

    iconInputObservacoes() {
      return this.mostraInputObservacoes ? 'done' : 'edit';
    },

    iconSearch() {
      return this.showSearch ? 'clear' : 'search';
    },

    checklistsOrdenados() {
      return this.atividadeChecklists.sort((a, b) => a.IdOrdem - b.IdOrdem);
    },

    // Filtra apenas as ocorrências do tipo 1 e 2 (Geral e Finalização) deixando de fora o tipo 2 (Log)
    tiposOcorrenciaFiltro() {
      return this.tiposOcorrencia.filter(tipo => tipo.IdTipoOcorrencia != 2);
    },

    atividadeProgresso() {
      if (this.atividadeChecklists.length) {
        let progress = this.atividadeChecklists.filter(check => check.Concluido);
        if (progress.length > 0) {
          let percentage = Math.floor((progress.length / this.atividadeChecklists.length) * 100);
          return percentage;
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    },
    hideLogOcorrenciasText() {
      return this.hideLogOcorrencias ? 'Mostrar Detalhes' : 'Ocultar Detalhes';
    },
    filteredOcorrencias() {
      if (this.hideLogOcorrencias) {
        return this.atividadeOcorrencias.filter(ocorrencia => ocorrencia.IdTipoOcorrencia !== 2);
      } else {
        return this.atividadeOcorrencias;
      }
    },
  }
}
</script>

<style scoped>
  .atividade-detalhes {
    display: flex;
    flex-wrap: wrap;
  }

  .prewrap {
    white-space: pre-wrap;
  }

  .concluido {
    text-decoration: line-through;
  }

  .z-index-1 {
    z-index: 1;
  }

  .ocorrencias-container {
    display: flex;
    flex-direction: column;
  }

  .order-1 {
    order: 1;
  }

  .order-2 {
    order: 2;
  }
  .pos-abs-fixed {
    z-index: 2;
    position: relative;
    padding-bottom: 40px;
  }

  .pos-abs-fixed > :first-child {
    position: fixed;
    z-index: 3;
  }

  .border-bottom > :first-child {
    border-bottom: 2px solid #999;
  }
</style>
